var map = {
	"./Messages.jpg": 326,
	"./Messages.png": 133,
	"./book.png": 134,
	"./box.png": 135,
	"./chat.png": 136,
	"./chat_01.png": 327,
	"./chat_02.png": 328,
	"./chat_icon.png": 329,
	"./cloud.png": 137,
	"./dashboard.png": 330,
	"./dot.png": 331,
	"./get_started_bg.png": 332,
	"./john.png": 138,
	"./left_leaf.png": 139,
	"./live_chat.png": 140,
	"./mobile.png": 141,
	"./panguin_img_one.png": 142,
	"./panguin_img_three.png": 143,
	"./panguin_img_two.png": 144,
	"./pluse.png": 145,
	"./richard.png": 146,
	"./right_leaf.png": 147,
	"./skyp_1.png": 333,
	"./skyp_2.png": 334,
	"./support_dashboard.jpg": 335,
	"./triangle.png": 148,
	"./video_icon.png": 336
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 70;